export const FEATURE_CMS_PAGE_CONTENT = 'cms-page-content';
